import React from 'react';
import UICheckbox from '../UICheckbox';
import './UICheckboxWithTextarea.scss';

// Props for the entire component
export interface UICheckboxWithTextareaProps {
  checkboxLabel: string;
  checked?: boolean;
  onCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  textareaValue?: string;
  onTextareaChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  textareaPlaceholder?: string;
  checkboxWidth?: number; // Width of checkbox container in percentage
  checkboxVariant?: 'default' | 'success' | 'error';
  checkboxSize?: 'small' | 'medium' | 'large';
  checkboxDisabled?: boolean;
  textareaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
  className?: string;
}

const UICheckboxWithTextarea: React.FC<UICheckboxWithTextareaProps> = ({
                                                                         checkboxLabel,
                                                                         checked = false,
                                                                         onCheckboxChange,
                                                                         textareaValue = '',
                                                                         onTextareaChange,
                                                                         textareaPlaceholder,
                                                                         checkboxWidth = 25, // Default checkbox container width
                                                                         checkboxVariant = 'default',
                                                                         checkboxSize = 'medium',
                                                                         checkboxDisabled = false,
                                                                         textareaProps,
                                                                         className = '',
                                                                       }) => {
  const checkboxContainerStyle = {
    flex: `0 0 ${checkboxWidth}%`,
  };

  const textareaStyle = {
    flex: '1',
  };

  return (
    <div className={`UICheckboxWithTextarea ${className}`}>
      <div
        className="UICheckboxWithTextarea__checkbox-container"
        style={checkboxContainerStyle}
      >
        <UICheckbox
          label={checkboxLabel}
          checked={checked}
          onChange={onCheckboxChange}
          variant={checkboxVariant}
          size={checkboxSize}
          disabled={checkboxDisabled}
        />
      </div>
      <textarea
        className="UICheckboxWithTextarea__textarea"
        style={textareaStyle}
        value={textareaValue}
        onChange={onTextareaChange}
        placeholder={textareaPlaceholder}
        disabled={!checked || checkboxDisabled} // Disabled если чекбокс не отмечен
        {...textareaProps}
      />
    </div>
  );
};

export default UICheckboxWithTextarea;